const createProps = (props, className) => {
  const { children } = props;

  if (typeof children === 'undefined') {
    return { className };
  }

  return {
    children,
    className,
  };
};

export default createProps;
